let accordions = Array.from(document.querySelectorAll(".accordion"));
accordions.forEach(
  (button) => {
    button.addEventListener("click", () => {
      let panel = button.nextElementSibling;
      if (panel.style.maxHeight) {
        button.classList.remove("activeAccordion");
        panel.style.maxHeight = null;
        panel.style.margin = "0";
      } else {
        button.classList.add("activeAccordion");
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.style.margin = "1em 0";
      }
    });
  }
);